<template>
    <div class="col-md-7 js-desktop-content" data-ident="rename" v-if="!pack.collectionFixed">
        <template v-if="!isCustomerLogged">
            <span class="link-underline">
                <svg class="ico ico--small ico--grey mr-1">
                    <use xlink:href="#edit"/>
                </svg>
                {{$t('components.BasketPackRename.renameBed')}}
                <div class="tooltip js-tooltip ml-1">
                    <span class="tooltip__icon">?</span>
                    <div class="tooltip__window">
                        Pokud u nás máte účet, můžete si uložit a pojmenovat vaši postel na příště.<br>
                        <a href="#popup-login" class="js-popup-open">Přihlašte se</a>. Pokud ještě nemáte účet, můžete se  <a href="#popup-login" class="js-popup-open">zaregistrovat</a>.
                    </div>
                </div>
            </span>
        </template>
        <template v-if="isCustomerLogged">
            <a class="link-underline"
               v-bind:class="{'d-none' : edit}"
               href="#" @click.prevent="editName"
            >
                <svg class="ico ico--small ico--grey mr-1">
                    <use xlink:href="#edit"/>
                </svg>
                <span v-if="bedName != ''">
                    {{bedName}}
                </span>
                <span v-else>
                    {{$t('components.BasketPackRename.renameBed')}}
                </span>
            </a>
            <div class=""  v-bind:class="{'d-none' : !edit}">
                <form class="d-flex" @submit.prevent="saveAsBed">
                    <label class="custom-formField--input mb-0">
                        <input ref="bedNameInput" type="text" placeholder="Název posltele" v-model="bedName"/>
                    </label>
                    <button class="ml-1 btn btn--secondary btn--small btn--black text-uppercase">
                        {{$t('components.BasketPackRename.save')}}
                    </button>
                </form>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                edit: false,
            };
        },
        props: ["pack"],
        computed: {
            bedName: {
                get: function() {
                    if( !this.pack.bedName ) {
                        return '';
                    } else {
                        return this.pack.bedName;
                    }
                },
                set: function(bedName) {
                    this.pack.bedName = bedName;
                }
            },
            isCustomerLogged: function() {
                return this.$store.getters.isCustomerLogged
            }
        },
        methods: {
            editName: function() {
                this.edit = true;
                var _this = this;
                this.$nextTick(function() { // focus on next rendering
                    _this.$refs.bedNameInput.focus();
                })
            },
            saveAsBed: function() {
                var items = this.pack.items;
                var bedComponents = [];
                items.forEach(function(item) {
                    var component = {
                        fkProductTypeId: item.productType.id,
                        quantity: item.quantity,
                    };

                    if(item.isCustom) {
                        component.width = item.itemCustomData.width;
                        component.length = item.itemCustomData.length;
                    } else {
                        var sizeTp = item.technicalParameters.find(function (tp) {
                            return tp.id == 1078;
                        });
                        var widthTp = sizeTp.value.children.find(function (tp) {
                            return tp.id == 1076;
                        });
                        var width = widthTp.value;

                        var lengthTp = sizeTp.value.children.find(function (tp) {
                            return tp.id == 1077;
                        });
                        var length = lengthTp.value;


                        component.width = width.value;
                        component.length = length.value;
                    }

                    bedComponents.push(component);
                });

                var fkBedTypeId = null;
                if('productSet' in this.pack
                    && this.pack.productSet ) {
                    // DOTO: use some translator
                    fkBedTypeId = this.pack.productSet.productSetType.id;
                }


                var _this = this;
                var bedName = this.bedName;
                var bed = {
                    id: _this.pack.bedId,
                    name: bedName,
                    fkBedTypeId: fkBedTypeId,
                    components: bedComponents,
                };
                this.$store.dispatch('ajaxSaveBed', {
                    basketItemPackUID: this.pack.uid,
                    bed: bed
                }).finally(function() {
                    _this.edit = false;
                });
            }
        }
    };
</script>